export default "__VITE_PUBLIC_ASSET__3a2e05f5__"